import { Controller, useFormContext } from "react-hook-form";
import CustomInput from "../../../Common/CustomInput";
import CustomSelect from "../../../Common/CustomSelect";
import { ratingScaleOptions } from "../../../../utils/surveys";

export const RatingQuestionItem = ({ questionName }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <div style={{ display: "flex", gap: "20px" }}>
                <Controller
                    control={control}
                    name={`${questionName}.lowerLabel`}
                    render={({ field }) => (
                        <CustomInput
                            errors={errors}
                            label="Lower Label *"
                            {...field}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`${questionName}.upperLabel`}
                    render={({ field }) => (
                        <CustomInput
                            errors={errors}
                            label="Upper Label *"
                            {...field}
                        />
                    )}
                />
            </div>
            <Controller
                control={control}
                name={`${questionName}.scale`}
                render={({ field }) => (
                    <CustomSelect
                        style={{ width: "100%" }}
                        errors={errors}
                        label="Scale variants"
                        valueKey="value"
                        labelKey="label"
                        options={ratingScaleOptions}
                        {...field}
                    />
                )}
            />
        </div>
    );
};
